import React from 'react';
import { PropTypes } from 'prop-types';
import { asyncComponent } from 'react-async-component';

import LoadingWrapper from 'components/Common/LoadingWrapper';
import BlankPage from 'components/Blanks/BlankPage';

const BlankLoadingComponent = () => (
  <BlankPage>
    <LoadingWrapper loaded={ false } />
  </BlankPage>
);

const BlankErrorComponent = ({ error }) => (
  <div>{ error.message }</div>
);
BlankErrorComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.any
};
BlankErrorComponent.defaultProps = {
  error: null
};

export const AsyncBlankBene = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8bene" */ '../../components/Blanks/BlankBene'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankBene2017 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8bene2017" */ '../../components/Blanks/BlankBene2017'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankBene2021 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8bene2021" */ '../../components/Blanks/BlankBene2021'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankBen = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8ben" */ '../../components/Blanks/BlankBen'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankBen2014 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8ben2014" */ '../../components/Blanks/BlankBen2014'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankBen2021 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8ben2021" */ '../../components/Blanks/BlankBen2021'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankEci = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8eci" */ '../../components/Blanks/BlankEci'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankEci2017 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8eci2017" */ '../../components/Blanks/BlankEci2017'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankEci2021 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8eci2021" */ '../../components/Blanks/BlankEci2021'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankExp = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8exp" */ '../../components/Blanks/BlankExp'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankExp2017 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8exp2017" */ '../../components/Blanks/BlankExp2017'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankImy = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8imy" */ '../../components/Blanks/BlankImy'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankImy2017 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w8imy2017" */ '../../components/Blanks/BlankImy2017'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankW9 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w9" */ '../../components/Blanks/BlankW9'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankW92017 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w92017" */ '../../components/Blanks/BlankW92017'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankW92018 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.w92018" */ '../../components/Blanks/BlankW92018'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankCrse = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.crse" */ '../../components/Blanks/BlankCrse'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankUCrse2019 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.ucrse2019" */ '../../components/Blanks/BlankUCrse2019'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankCrseBba = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.crsebba" */ '../../components/Blanks/BlankCrseBba'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankCrsCp = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.crscp" */ '../../components/Blanks/BlankCrsCp'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankUCrsCp2019 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.ucrscp2019" */ '../../components/Blanks/BlankUCrsCp2019'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankCrsi = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.crsi" */ '../../components/Blanks/BlankCrsi'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankRc519 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.Rc519" */ '../../components/Blanks/BlankRc519'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});

export const AsyncBlankRc518 = asyncComponent({
  resolve: () => import(/* webpackChunkName: "blank.Rc518" */ '../../components/Blanks/BlankRc518'),
  LoadingComponent: BlankLoadingComponent,
  ErrorComponent: BlankErrorComponent
});
